import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { getAllData, rechargeLog, rechargeCount, customerCount, consumptionLog, consumptionCount, rechargeTypeList } from '@/service/sale/count';
import { DAYJS_FORMAT } from '@/config/common';
// 统计信息
export default function countInfo(params, logType) {
  var page = {
    page: 1,
    list_rows: 10
  };
  var listFinished = ref(false);
  var listLoading = ref(false);
  // 时间区间
  var timeRange = computed(function () {
    if (params.type === 0) {
      return {
        startTime: dayjs(params.date).startOf('day').format(DAYJS_FORMAT.YYYYMMDD_HHMMSS),
        endTime: dayjs(params.date).endOf('day').format(DAYJS_FORMAT.YYYYMMDD_HHMMSS)
      };
    } else if (params.type === 1) {
      return {
        startTime: dayjs(params.date).startOf('month').format(DAYJS_FORMAT.YYYYMMDD_HHMMSS),
        endTime: dayjs(params.date).endOf('month').format(DAYJS_FORMAT.YYYYMMDD_HHMMSS)
      };
    } else if (params.type === 2) {
      return {
        startTime: dayjs(params.date).startOf('year').format(DAYJS_FORMAT.YYYYMMDD_HHMMSS),
        endTime: dayjs(params.date).endOf('year').format(DAYJS_FORMAT.YYYYMMDD_HHMMSS)
      };
    } else {
      return {
        startTime: '',
        endTime: ''
      };
    }
  });
  // 统计信息
  var countVal = ref({
    orderCount: '',
    carCount: ''
  });
  var getCountInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getAllData(timeRange.value);
          case 2:
            data = _context.sent;
            countVal.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getCountInfo() {
      return _ref.apply(this, arguments);
    };
  }();
  // 新增客户
  var customerCountInfo = ref({
    userCount: ''
  });
  var getCustomerCountInfo = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return customerCount(timeRange.value);
          case 2:
            data = _context2.sent;
            customerCountInfo.value = data;
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getCustomerCountInfo() {
      return _ref2.apply(this, arguments);
    };
  }();
  // 充值记录
  var logInfo = ref([]);
  var getLogInfo = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var _logInfo$value;
      var data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            listLoading.value = true;
            if (!(logType === '充值(元)')) {
              _context3.next = 7;
              break;
            }
            _context3.next = 4;
            return rechargeLog(Object.assign({}, page, timeRange.value));
          case 4:
            data = _context3.sent;
            _context3.next = 10;
            break;
          case 7:
            _context3.next = 9;
            return consumptionLog(Object.assign({}, page, timeRange.value));
          case 9:
            data = _context3.sent;
          case 10:
            if (Array.isArray(data)) {
              _context3.next = 12;
              break;
            }
            return _context3.abrupt("return");
          case 12:
            (_logInfo$value = logInfo.value).push.apply(_logInfo$value, _toConsumableArray(data));
            listLoading.value = false;
            page.page++;
            if (data.length < page.list_rows) {
              listFinished.value = true;
            }
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function getLogInfo() {
      return _ref3.apply(this, arguments);
    };
  }();
  // 充值方式
  var rechargeTypeInfo = ref({
    money: []
  });
  var getRechargeTypeInfo = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var data;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return rechargeTypeList(timeRange.value);
          case 2:
            data = _context4.sent;
            rechargeTypeInfo.value = data;
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function getRechargeTypeInfo() {
      return _ref4.apply(this, arguments);
    };
  }();
  // 充值统计
  var rechargeCountInfo = ref({
    upDownMoney: '',
    upOnMoney: ''
  });
  var getRechargeCountInfo = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var data;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return rechargeCount(timeRange.value);
          case 2:
            data = _context5.sent;
            rechargeCountInfo.value = data;
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function getRechargeCountInfo() {
      return _ref5.apply(this, arguments);
    };
  }();
  // 消费统计
  var consumptionCountInfo = ref({
    saleUpMoney: '',
    saleDownMoney: ''
  });
  var getConsumptionCountInfo = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var data;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return consumptionCount(timeRange.value);
          case 2:
            data = _context6.sent;
            consumptionCountInfo.value = data;
          case 4:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function getConsumptionCountInfo() {
      return _ref6.apply(this, arguments);
    };
  }();
  //重置分页
  var resetPage = function resetPage() {
    page.page = 1;
    logInfo.value = [];
    listFinished.value = false;
    listLoading.value = false;
  };
  return {
    resetPage: resetPage,
    listFinished: listFinished,
    listLoading: listLoading,
    countVal: countVal,
    getCountInfo: getCountInfo,
    customerCountInfo: customerCountInfo,
    getCustomerCountInfo: getCustomerCountInfo,
    logInfo: logInfo,
    getLogInfo: getLogInfo,
    rechargeTypeInfo: rechargeTypeInfo,
    getRechargeTypeInfo: getRechargeTypeInfo,
    rechargeCountInfo: rechargeCountInfo,
    getRechargeCountInfo: getRechargeCountInfo,
    consumptionCountInfo: consumptionCountInfo,
    getConsumptionCountInfo: getConsumptionCountInfo
  };
}